module.exports = __webpack_public_path__ + "static/media/product_image_3.bbbabf9c.png";